import { render, staticRenderFns } from "./CtaOne.vue?vue&type=template&id=0963da25&"
import script from "./CtaOne.vue?vue&type=script&lang=js&"
export * from "./CtaOne.vue?vue&type=script&lang=js&"
import style0 from "./CtaOne.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports